import { render } from "./FilterMecanicos.vue?vue&type=template&id=b844919a&ts=true"
import script from "./FilterMecanicos.vue?vue&type=script&lang=ts"
export * from "./FilterMecanicos.vue?vue&type=script&lang=ts"

import "./FilterMecanicos.vue?vue&type=style&index=0&id=b844919a&lang=scss"

import exportComponent from "/Users/camp/Desktop/code-time/acampa-gestao-pra/vuecode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__